import { UploadFail } from 'reactApp/modules/uploading/fails/UploadFail';

export class ConnectionFail extends UploadFail {
    CONNECTION_FAILURE = 0;

    radarName = 'fail_{SOURCE}_connection';
    message = 'Разрыв соединения.';
}
